const SHOW = '@@DVA_LOADING/SHOW';
const HIDE = '@@DVA_LOADING/HIDE';
const NAMESPACE = 'loading';
// opts = {effects: false, namespace: 'loading', trackedActions: null}
function createLoading(opts = {}) {
  const loadingNamespace = opts.namespace || NAMESPACE;
  const initialState = {
    global: false,
    models: {},
  };

  if (opts.effects) {
    initialState.effects = {};
  }

  if (opts.trackedActions) {
    initialState.trackedActionCounter = 0;
    initialState.appReady = false;
  }

  const extraReducers = {
    [loadingNamespace](state = initialState, { type, payload }) {
      const { namespace, actionType, status } = payload || {};
      let ret;
      switch (type) {
        case SHOW: {
          ret = {
            ...state,
            global: true,
            models: { ...state.models, [namespace]: true },
          };
          if (opts.effects) {
            ret.effects = {
              ...state.effects,
              [actionType]: {
                ...state.effects[actionType],
                status: 'loading',
              },
            };
          }
          break;
        }
        case HIDE: {
          const models = { ...state.models, [namespace]: false };
          const global = Object.keys(models).some(nsp => models[nsp]);
          ret = {
            ...state,
            global,
            models,
          };
          if (opts.effects) {
            ret.effects = {
              ...state.effects,
              [actionType]: {
                ...state.effects[actionType],
                status,
              },
            };
            if (status === 'success') ret.effects[actionType].loaded = true;
          }
          if (opts.trackedActions) {
            const trackedActionCounter = state.trackedActionCounter;
            if (trackedActionCounter < opts.trackedActions.length && opts.trackedActions.indexOf(actionType) !== -1) {
              ret.trackedActionCounter = trackedActionCounter + 1;
              if (ret.trackedActionCounter === opts.trackedActions.length) ret.appReady = true;
            }
          }
          break;
        }
        default:
          ret = state;
          break;
      }
      // console.log(ret);
      return ret;
    },
  };

  function onEffect(effect, { put }, model, actionType) {
    const { namespace } = model;
    return function* (...args) {
      yield put({ type: SHOW, payload: { namespace, actionType } });
      const output = {};
      if (args && args.length > 0) {
        args[0].output = output;
      }
      yield effect(...args);
      if (args[0].onComplete) {
        args[0].onComplete(output.value);
      }
      let status = 'success';
      if (output.value && 'success' in output.value) {
        status = output.value.success ? 'success' : 'error';
      }
      yield put({ type: HIDE, payload: { namespace, actionType, status } });
    };
  }

  return {
    extraReducers,
    onEffect,
  };
}

export default createLoading;

export const getAsyncStatus = (state, action) => state.loading.effects[action] && state.loading.effects[action].status;



// WEBPACK FOOTER //
// ./src/models/loading.js